/* eslint-disable max-len */
import React, { useRef } from 'react';
import { Typography } from '@vtblife/uikit';
import { Spinner, Size } from '@vtblife/uikit/legacy';
import classname from '@search/classname/src';
import { useProfAgentContext } from '../AgentFavoritesProvider/AgentFavoritesProvider';
import { AgentSavedSearchRadioItem } from './AgentSavedSearchRadioItem/AgentSavedSearchRadioItem';
import { AgentCustomersRadioCreate } from './AgentCustomersRadioCreate/AgentCustomersRadioCreate';

import './AgentCustomersRadioList.css';

interface IAgentCustomersRadioList {
    forMe: boolean;
    onForMe: (v: boolean) => void;
    limitHeight?: boolean;
    selectedIds: Array<('me' | string)>;
    onSelect: (customerId: string) => void;
}

const cn = classname.bind(null, 'AgentCustomersRadioList');

export const AgentCustomersRadioList: React.FC<IAgentCustomersRadioList> = ({
    forMe,
    onForMe,
    limitHeight,
    selectedIds,
    onSelect
}) => {
    const listRef = useRef<HTMLDivElement>(null);

    const {
        customers,
        handleAddCustomerToList,
    } = useProfAgentContext();

    if ((customers ?? null) === null) {
        return (<div className={cn()}>
            <div className={cn('loader')}>
                <Spinner size={Size.Medium} />
            </div>
        </div>);
    }

    return (
        <div className={cn()} data-test={'offer-like-list'}>
            <div className={cn('title')}>
                <Typography variant='h4'>Выберите куда сохранить</Typography>
            </div>
            {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
            <div className={cn('list', { 'limit-height': limitHeight })} ref={listRef}>

                <AgentSavedSearchRadioItem
                    isLike={forMe}
                    name='Мои поиски'
                    onChange={() => onForMe(! forMe)}
                />
                {Object.keys((customers ?? {})).map(customerId => {
                    const customer = (customers ?? {})[customerId];

                    return (
                        <AgentSavedSearchRadioItem
                            key={customerId}
                            isLike={selectedIds.includes(customerId)}
                            name={customer.name}
                            onChange={() => {
                                onSelect(customerId);
                            }}
                        />
                    );
                })}
            </div>
            <div className={cn('create')}>
                <AgentCustomersRadioCreate
                    onAddCustomer={(customer) => {
                        handleAddCustomerToList(customer);
                        onSelect(customer.id);
                    }}
                />
            </div>
        </div>
    );
};
